import { FormattedMessage } from "react-intl";
import MainView from "views/MainView";
import { _H5Event, handleFromAppParams } from "request";
import { useEffect } from "react";
import { useIntlContext } from "views/IntlContext";

export const Alexa = () => {
  const { switchLanguage } = useIntlContext();

  useEffect(() => {
    const datas = {
      event: "GetTokenAndLanguage",
      pageName: "alexa",
      callback: (responseStr: any) => {
        const jsonData = handleFromAppParams(responseStr);
        switchLanguage?.(jsonData.lang);
      },
    };
    _H5Event(datas);
  }, []);

  return (
    <MainView backgroundClassName="bg-white dark:bg-black1b1f1e">
      <div className="break-words text-sm">
        <div className="w-full h-[10px] bg-page"></div>
        <div className="p-6">
          <h1 className="font-bold text-2xl mb-8">
            <FormattedMessage id="helpCenter.alexa.title" />
          </h1>
          <p className="font-medium mt-4 text-base">
            <FormattedMessage id="helpCenter.alexa.item1.title" />
          </p>
          <ul className="list-disc pl-[1.5em] mt-4 text-gray666 dark:text-white60">
            <li className="mb-2">
              <FormattedMessage id="helpCenter.alexa.item1.content1" />
            </li>
            <li className="mb-2">
              <FormattedMessage id="helpCenter.alexa.item1.content2" />
            </li>
          </ul>
          <p className="font-medium mt-6 text-base">
            <FormattedMessage id="helpCenter.alexa.item2.title" />
          </p>
          <ul className="list-disc pl-[1.5em] mt-4 text-gray666 dark:text-white60">
            <li className="mb-2">
              <FormattedMessage id="helpCenter.alexa.item2.content1" />
            </li>
            <li className="mb-2">
              <FormattedMessage id="helpCenter.alexa.item2.content2" />
            </li>
            <li className="mb-2">
              <FormattedMessage id="helpCenter.alexa.item2.content3" />
            </li>
            <li className="mb-2">
              <FormattedMessage id="helpCenter.alexa.item2.content4" />
            </li>
            <li className="mb-2">
              <FormattedMessage id="helpCenter.alexa.item2.content5" />
            </li>
          </ul>
          <p className="font-medium mt-8 text-base">
            <FormattedMessage id="helpCenter.alexa.item3.title" />
          </p>
        </div>
      </div>
    </MainView>
  );
};
